export default {
  route: {
    home: 'Home Page',
    product: 'Product',
    news: 'News Center',
    application: 'Industry',
    company: 'Company',
    employ: 'Recruiting',
    contactUs: 'Contact Us',
    postRecruitment: 'Post Recruitment',
  },
  footer:{
    contactUs: "Contact US",
    telephone: "Telephone",
    email: "Email",
    address: "Address",
    link: "Link",
    focusUs: "Focus Us",
  },
  home:{
    managerMsg: "Message from the General Manager",
    aboutUs: "About US",
    productIntrudiction: "Product intrudiction",
    industryApplication: "Industry application",
    newsCenter: "News Center",
    companyNews: "Company News",
    industryNews: "Industry News",
  },
  product: {
    param: "Parameters",
    radius: "Operational radius",
    altitude: "cruise altitude",
    speed: "Maximum speed",
    emptyTime: "Empty Time",
    overload: "Maximum overload",
    resistance: "Wind resistance",
    weight: "Flight Weight",
    taskLoad: "Task load",
    mode: "Navigation mode",
    accuracy: "Attack accuracy",
    rate: "Hit Rate",
    task: "Mission Objectives",
    level: "Level",
  },
  common: {
    pre: "Pre",
    next: "Next",
    cancel: "Cancel",
    delivery: "Delivery",
  },
  news: {
    allNews: "All News",
    companyNews: "Company News",
    industryNews: "Industry News",
    detail: "Detail",
  },
  industry: {
    platformProfile: "Platform Profile",
    platformAdvantages: "Platform Advantages",
    industryApplication: "Industry Application",
    industryAdvantages: "Industry Advantages",
    publicSafety: "Public Safety",
    patrol: "Patrol",
    fireFighting: "Emergency fire fighting",
  },
  company: {
    companyProfile: "Company Profile",
    advantage: "R & D Advantage",
    workshop: "Brief Introduction of Workshop of Scientific Research and Production Department",
    employee: "Expert consultants and team introduction",
    culture: "Enterprise culture",
    vision: "Company Vision",
    process: "Development process",
    honor: "Qualification Honor",
  },
  employ: {
    jobDesc: "Job Description",
    joinUs: "Join us",
    qualifications: "Qualifications",
    resumeDelivery: "Resume Delivery",
    post: "Post",
    name: "Name",
    birthDate: "Birth Date",
    selectBirthDate: "Please select your Birth Date",
    gender: "gender",
    selectGender: "Please select your gender",
    male: "男",
    female: "女",
    enterName: "Please enter your name",
    contact: "Contact",
    enterContact: "Please enter your contact",
    uploadResume: "Upload Resume",
    drag: "Drag the file here, or",
    clickUpload: " Click Upload",

    contactUs: "Contact Us",
    address: "Address",
    contactPhone: "TelePhone",
    marketSales: "Sales",
    weChatPublic: "WeChat",
    onlinemessage: "online message",
    name: "Name",
    contact: "Contact",
    companyAddress: "Address",
    email: "Email",
    demand: "Demand",
    message: "Message",
  },
}
